<template>
    <div class="outer-box" >
      <h4>Verify the account</h4>
  
      <div class="inner-box" style="text-align: left; width: 500px;">
        <input
          class="hl_input--wrap "
          type="text"
          placeholder="Enter Agency Relationship Number"
          v-model.trim="relationshipNumber"
        />
        <p v-if="error" style="color: red;">{{errorMsg}}</p>
        <button class="btn btn-primary mt-4" @click="resetVerification" :disabled="!relationshipNumber || processing || error">
          <moon-loader v-if="processing" :loading="true" size="21px" color="#fafafa" />
          <span v-else> Verify Account</span>
        </button>
        <pre v-if="response" style="background-color: #f2f7fa;padding: 16px; margin-top: 16px">{{response}}</pre>
      </div>
    </div>
  </template>
  
  <script>
  import { OnboardingService, InternalToolsService } from "@/services";
  export default {
    data() {
      return {
        relationshipNumber: '',
        processing: false,
        response: null,
        error: false,
        errorMsg: ''
      };
    },
    watch: {
      relationshipNumber(value) {
        this.validateRelationshipNumber(value);
      }
    },
    methods: {
      async validateRelationshipNumber(value) {
        this.error = false

        let regex = /^\d{1}-\d{3}-\d{3}$/;
        const isValidFormat = regex.test(value)

        if(!isValidFormat) {
          this.error = true
          this.errorMsg = 'Please check relationship number format. Eg: X-XXX-XXX'
        }
      },
      async resetVerification(){
        try {
            this.processing = true
            this.error = false
            
            const { data: companyData } = await InternalToolsService.getCompanyByRelationshipNumber({ value: this.relationshipNumber })
            let companyId = companyData?.id;
          
            const body = {
              companyId,
              isEmailVerified: true,
              isPhoneVerified: true
            }
            const {data} = await OnboardingService.resetVerification(body);

            this.response = data

            this.processing = false;
        } catch (error) {
            this.processing = false;
            this.response = 'Agency Relationship Number not found'
            console.error(error);
        }
      },
    }
  }
  </script>
  
  <style>
  </style>
  